import { StyledArrowContainer } from 'src/components/buttons/ArrowButton/ArrowButton.styles';
import { addTransition } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

export const StyledSinglePageContainer = styled.div`
	position: relative;
	height: 100%;

	& > ${StyledArrowContainer} {
		z-index: 500;
	}
`;

export const StyledDotsContainer = styled.div<{ isHidden: boolean; addBackground?: boolean }>`
	position: fixed;
	bottom: 0;
	left: 0;

	z-index: 500;

	${addTransition()}

	${(p) => css`
		&::before {
			content: ' ';
			position: absolute;
			bottom: 0;
			left: 0%;
			right: 0%;

			pointer-events: none;

			height: 150%;

			${addTransition('opacity')}

			opacity: 0;

			background: linear-gradient(to bottom, ${p.theme.colors.black}00 0%, ${p.theme.colors.black} 100%);
		}

		${p.isHidden ? `opacity: 0; user-select: none; cursor: default; pointer-events: none;` : `opacity: 1;`}
		${p.addBackground ? `&::before { opacity: 1; }` : ''}
	`}

	width: 100vw;

	height: 50px;
`;
